import { render, staticRenderFns } from "./globalFunc.vue?vue&type=template&id=2cf5a8e6&scoped=true&"
import script from "./globalFunc.vue?vue&type=script&lang=js&"
export * from "./globalFunc.vue?vue&type=script&lang=js&"
import style0 from "./globalFunc.vue?vue&type=style&index=0&id=2cf5a8e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5a8e6",
  null
  
)

export default component.exports